import DeleteIcon from "@mui/icons-material/Delete";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import SendIcon from "@mui/icons-material/Send";
import DownloadIcon from "@mui/icons-material/Download";
import MessageIcon from "@mui/icons-material/Message";
import InfoIcon from "@mui/icons-material/Info";
import VisibilityRoundedIcon from "@mui/icons-material/VisibilityRounded";
import FilePresentIcon from "@mui/icons-material/FilePresent";
import FilterAltRoundedIcon from "@mui/icons-material/FilterAltRounded";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import RestartAltRoundedIcon from "@mui/icons-material/RestartAltRounded";
import SearchIcon from "@mui/icons-material/Search";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import ReplyRoundedIcon from "@mui/icons-material/ReplyRounded";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import HomeIcon from "@mui/icons-material/Home";
import DashboardCustomizeOutlinedIcon from "@mui/icons-material/DashboardCustomizeOutlined";
import PeopleOutlineOutlinedIcon from "@mui/icons-material/PeopleOutlineOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import PaymentIcon from "@mui/icons-material/Payment";
import AssessmentIcon from "@mui/icons-material/Assessment";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import CloseIcon from "@mui/icons-material/Close";
import AirplanemodeActiveIcon from "@mui/icons-material/AirplanemodeActive";
import Check from "@mui/icons-material/Check";
import SettingsIcon from "@mui/icons-material/Settings";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import VideoLabelIcon from "@mui/icons-material/VideoLabel";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ModeEditOutlineSharpIcon from "@mui/icons-material/ModeEditOutlineSharp";
import CancelIcon from "@mui/icons-material/Cancel";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import BarChartIcon from "@mui/icons-material/BarChart";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import BlockIcon from "@mui/icons-material/Block";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import WarningIcon from "@mui/icons-material/Warning";
import DescriptionIcon from "@mui/icons-material/Description";
import BlockOutlinedIcon from "@mui/icons-material/BlockOutlined";
import GppGoodOutlinedIcon from "@mui/icons-material/GppGoodOutlined";
import NotificationsOffOutlinedIcon from "@mui/icons-material/NotificationsOffOutlined";
import NoAccountsOutlinedIcon from "@mui/icons-material/NoAccountsOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import NotificationsNoneRoundedIcon from "@mui/icons-material/NotificationsNoneRounded";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import AddCommentIcon from "@mui/icons-material/AddComment";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ReplyIcon from "@mui/icons-material/Reply";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import StayCurrentPortraitOutlinedIcon from "@mui/icons-material/StayCurrentPortraitOutlined";
import LaptopOutlinedIcon from "@mui/icons-material/LaptopOutlined";
import LinkOutlinedIcon from "@mui/icons-material/LinkOutlined";
import VerifiedIcon from "@mui/icons-material/Verified";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import FilterListIcon from "@mui/icons-material/FilterList";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import WifiIcon from "@mui/icons-material/Wifi";
import WifiOffIcon from "@mui/icons-material/WifiOff";
import CircleIcon from "@mui/icons-material/Circle";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import PauseCircleIcon from "@mui/icons-material/PauseCircle";
import RefreshIcon from "@mui/icons-material/Refresh";
import MailIcon from "@mui/icons-material/Mail";
import ShieldIcon from "@mui/icons-material/Shield";
import PersonIcon from "@mui/icons-material/Person";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import SecurityIcon from "@mui/icons-material/Security";
import PrivacyTipIcon from "@mui/icons-material/PrivacyTip";
import AssignmentIcon from "@mui/icons-material/Assignment";
import LockIcon from "@mui/icons-material/Lock";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import TableRowsIcon from "@mui/icons-material/TableRows";
import ViewWeekIcon from "@mui/icons-material/ViewWeek";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import BusinessIcon from "@mui/icons-material/Business";
import EmailIcon from "@mui/icons-material/Email";
import LanguageIcon from "@mui/icons-material/Language";
import PhoneIcon from "@mui/icons-material/Phone";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import MoneyIcon from "@mui/icons-material/Money";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import HelpIcon from "@mui/icons-material/Help";
import StarIcon from "@mui/icons-material/Star";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import MapIcon from '@mui/icons-material/Map';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import FactCheckIcon from "@mui/icons-material/FactCheck";
import { DoNotDisturbOn, HourglassEmpty, ReceiptLong, TaskAlt } from "@mui/icons-material";
import AutorenewIcon from '@mui/icons-material/Autorenew';
export const PrimaryColor = "#22419e";

export const MyAutorenewIcon = ({ sx, ...props }) => (
  <AutorenewIcon sx={{ color: "#22419e", ...sx }} {...props} />
);
export const MyExportIcon = ({ sx, ...props }) => (
  <FileUploadIcon sx={{ color: "#22419e", ...sx }} {...props} />
);
export const MyPersonAddIcon = ({ sx, ...props }) => (
  <PersonAddIcon sx={{ color: "#22419e", ...sx }} {...props} />
);
export const MyHourglassEmptyIcon = ({ sx, ...props }) => (
  <HourglassEmpty sx={{ color: "#22419e", ...sx }} {...props} />
);
export const MyDoNotDisturbOnIcon = ({ sx, ...props }) => (
  <DoNotDisturbOn sx={{ color: "#22419e", ...sx }} {...props} />
);
export const MyReceiptLongIcon = ({ sx, ...props }) => (
  <ReceiptLong sx={{ color: "#22419e", ...sx }} {...props} />
);
export const MyTaskAltIcon = ({ sx, ...props }) => (
  <TaskAlt sx={{ color: "#22419e", ...sx }} {...props} />
);



export const MyHelpIcon = ({ sx, ...props }) => (
  <HelpIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyStarIcon = ({ sx, ...props }) => (
  <StarIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyLocationIcon = ({ sx, ...props }) => (
  <LocationOnIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyMapIcon = ({ sx, ...props }) => (
  <MapIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyCalendarIcon = ({ sx, ...props }) => (
  <CalendarTodayIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyMoneyIcon = ({ sx, ...props }) => (
  <MoneyIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyAttachMoneyIcon = ({ sx, ...props }) => (
  <AttachMoneyIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyBusinessIcon = ({ sx, ...props }) => (
  <BusinessIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyEmailIcon = ({ sx, ...props }) => (
  <EmailIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyLanguageIcon = ({ sx, ...props }) => (
  <LanguageIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyPhoneIcon = ({ sx, ...props }) => (
  <PhoneIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyDeleteIcon = ({ sx, ...props }) => (
  <DeleteIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyViewWeekIcon = ({ sx, ...props }) => (
  <ViewWeekIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyRadioButtonUncheckedIcon = ({ sx, ...props }) => (
  <RadioButtonUncheckedIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyTableRowsIcon = ({ sx, ...props }) => (
  <TableRowsIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyAccessTimeIcon = ({ sx, ...props }) => (
  <AccessTimeIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyEditIcon = ({ sx, ...props }) => (
  <EditRoundedIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MySendIcon = ({ sx, ...props }) => (
  <SendIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyDownloadIcon = ({ sx, ...props }) => (
  <DownloadIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyMessageIcon = ({ sx, ...props }) => (
  <MessageIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyInfoIcon = ({ sx, ...props }) => (
  <InfoIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyViewIcon = ({ sx, ...props }) => (
  <VisibilityRoundedIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyFilePresentIcon = ({ sx, ...props }) => (
  <FilePresentIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyFilterIcon = ({ sx, ...props }) => (
  <FilterAltRoundedIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyEditOutlinedIcon = ({ sx, ...props }) => (
  <EditOutlinedIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyDeleteOutlineOutlinedIcon = ({ sx, ...props }) => (
  <DeleteOutlineOutlinedIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyFilterAltOutlinedIcon = ({ sx, ...props }) => (
  <FilterAltOutlinedIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyAddRoundedIcon = ({ sx, ...props }) => (
  <AddRoundedIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyRestartAltRoundedIcon = ({ sx, ...props }) => (
  <RestartAltRoundedIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MySearchIcon = ({ sx, ...props }) => (
  <SearchIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyArrowBackIosRoundedIcon = ({ sx, ...props }) => (
  <ArrowBackIosRoundedIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyReplyRoundedIcon = ({ sx, ...props }) => (
  <ReplyRoundedIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyVisibilityIcon = ({ sx, ...props }) => (
  <VisibilityIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyVisibilityOffIcon = ({ sx, ...props }) => (
  <VisibilityOffIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyHomeIcon = ({ sx, ...props }) => (
  <HomeIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyDashboardCustomizeOutlinedIcon = ({ sx, ...props }) => (
  <DashboardCustomizeOutlinedIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyPeopleOutlineOutlinedIcon = ({ sx, ...props }) => (
  <PeopleOutlineOutlinedIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyArticleOutlinedIcon = ({ sx, ...props }) => (
  <ArticleOutlinedIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MySupportAgentIcon = ({ sx, ...props }) => (
  <SupportAgentIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyAddIcon = ({ sx, ...props }) => (
  <AddIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyRemoveIcon = ({ sx, ...props }) => (
  <RemoveIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyPaymentIcon = ({ sx, ...props }) => (
  <PaymentIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyAssessmentIcon = ({ sx, ...props }) => (
  <AssessmentIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyWorkspacePremiumIcon = ({ sx, ...props }) => (
  <WorkspacePremiumIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyCloseIcon = ({ sx, ...props }) => (
  <CloseIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyAirplanemodeActiveIcon = ({ sx, ...props }) => (
  <AirplanemodeActiveIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyCheckIcon = ({ sx, ...props }) => (
  <Check sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MySettingsIcon = ({ sx, ...props }) => (
  <SettingsIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyGroupAddIcon = ({ sx, ...props }) => (
  <GroupAddIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyVideoLabelIcon = ({ sx, ...props }) => (
  <VideoLabelIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyArrowBackIcon = ({ sx, ...props }) => (
  <ArrowBackIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyModeEditOutlineSharpIcon = ({ sx, ...props }) => (
  <ModeEditOutlineSharpIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyCancelIcon = ({ sx, ...props }) => (
  <CancelIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyMoreVertIcon = ({ sx, ...props }) => (
  <MoreVertIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyBarChartIcon = ({ sx, ...props }) => (
  <BarChartIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyVisibilityOutlinedIcon = ({ sx, ...props }) => (
  <VisibilityOutlinedIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyCheckCircleOutlineIcon = ({ sx, ...props }) => (
  <CheckCircleOutlineIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyBlockIcon = ({ sx, ...props }) => (
  <BlockIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyDescriptionOutlinedIcon = ({ sx, ...props }) => (
  <DescriptionOutlinedIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyWarningIcon = ({ sx, ...props }) => (
  <WarningIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyDescriptionIcon = ({ sx, ...props }) => (
  <DescriptionIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyBlockOutlinedIcon = ({ sx, ...props }) => (
  <BlockOutlinedIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyGppGoodOutlinedIcon = ({ sx, ...props }) => (
  <GppGoodOutlinedIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyNotificationsOffOutlinedIcon = ({ sx, ...props }) => (
  <NotificationsOffOutlinedIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyNoAccountsOutlinedIcon = ({ sx, ...props }) => (
  <NoAccountsOutlinedIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyCheckCircleOutlineOutlinedIcon = ({ sx, ...props }) => (
  <CheckCircleOutlineOutlinedIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyNotificationsNoneRoundedIcon = ({ sx, ...props }) => (
  <NotificationsNoneRoundedIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyPictureAsPdfIcon = ({ sx, ...props }) => (
  <PictureAsPdfIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyRemoveRedEyeOutlinedIcon = ({ sx, ...props }) => (
  <RemoveRedEyeOutlinedIcon sx={{ ...sx }} {...props} />
);

export const MyFileDownloadIcon = ({ sx, ...props }) => (
  <FileDownloadIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyBorderColorOutlinedIcon = ({ sx, ...props }) => (
  <BorderColorOutlinedIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyDeleteForeverOutlinedIcon = ({ sx, ...props }) => (
  <DeleteForeverOutlinedIcon sx={{  ...sx }} {...props} />
);

export const MyAddCommentIcon = ({ sx, ...props }) => (
  <AddCommentIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyArrowUpwardIcon = ({ sx, ...props }) => (
  <ArrowUpwardIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyAccountCircleIcon = ({ sx, ...props }) => (
  <AccountCircleIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyReplyIcon = ({ sx, ...props }) => (
  <ReplyIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyInfoOutlinedIcon = ({ sx, ...props }) => (
  <InfoOutlinedIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyStayCurrentPortraitOutlinedIcon = ({ sx, ...props }) => (
  <StayCurrentPortraitOutlinedIcon
    sx={{ color: "#22419e", ...sx }}
    {...props}
  />
);

export const MyLaptopOutlinedIcon = ({ sx, ...props }) => (
  <LaptopOutlinedIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyLinkOutlinedIcon = ({ sx, ...props }) => (
  <LinkOutlinedIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyVerifiedIcon = ({ sx, ...props }) => (
  <VerifiedIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyMonetizationOnOutlinedIcon = ({ sx, ...props }) => (
  <MonetizationOnOutlinedIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyFilterListIcon = ({ sx, ...props }) => (
  <FilterListIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyWarningAmberIcon = ({ sx, ...props }) => (
  <WarningAmberIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyCheckCircleIcon = ({ sx, ...props }) => (
  <CheckCircleIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyCreditCardIcon = ({ sx, ...props }) => (
  <CreditCardIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyWifiIcon = ({ sx, ...props }) => (
  <WifiIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyWifiOffIcon = ({ sx, ...props }) => (
  <WifiOffIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyCircleIcon = ({ sx, ...props }) => (
  <CircleIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyAttachFileIcon = ({ sx, ...props }) => (
  <AttachFileIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyPauseCircleIcon = ({ sx, ...props }) => (
  <PauseCircleIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyRefreshIcon = ({ sx, ...props }) => (
  <RefreshIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyMailIcon = ({ sx, ...props }) => (
  <MailIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyShieldIcon = ({ sx, ...props }) => (
  <ShieldIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyPersonIcon = ({ sx, ...props }) => (
  <PersonIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyAccountBalanceWalletIcon = ({ sx, ...props }) => (
  <AccountBalanceWalletIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MySecurityIcon = ({ sx, ...props }) => (
  <SecurityIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyPrivacyTipIcon = ({ sx, ...props }) => (
  <PrivacyTipIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyAssignmentIcon = ({ sx, ...props }) => (
  <AssignmentIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyLockIcon = ({ sx, ...props }) => (
  <LockIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyAccountBalanceIcon = ({ sx, ...props }) => (
  <AccountBalanceIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyUnblockIcon = ({ sx, ...props }) => (
  <LockOpenIcon sx={{ color: "#22419e", ...sx }} {...props} />
);

export const MyPreviewIcon = ({ sx, ...props }) => (
  <FactCheckIcon sx={{ color: "#22419e", ...sx }} {...props} />
);
export const MyCheckboxIcon = {
  "&.Mui-checked": {
    color: "#22419e",
  },
};
